import React, { useState } from 'react';
import { BiSupport } from 'react-icons/bi';
import SupportModal from './SupportModal';
import styles from './FloatingSupportButton.module.css';

function FloatingSupportButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className={styles.floatingButton} onClick={handleOpenModal} title="Contact Support">
        <BiSupport className={styles.icon} />
      </div>

      {isModalOpen && <SupportModal onClose={handleCloseModal} />}
    </>
  );
}

export default FloatingSupportButton;
